<ng-container *ngIf="activeColumnsNames$ | async as activeColumnsNames">
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('userNameMenu',true)"
    scope="col"
    class="option no-padding column campaign"
    [ngClass]="{'active': availableMenus.userNameMenu, 'wider-column' : true, 'active-sort': activeFilterMenus.userNameMenu}"
    *ngIf="title === 'referrals'">
    <div class="clickable" (click)="menuHandler('userNameMenu')">
      <span>{{ 'view_translations.username' | translate }}</span>
      <div class="icons-container">
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter"
          *ngIf="activeSortMethod?.orderField === 'username'"></nb-icon>
      </div>
    </div>
    <div class="column-menu" [ngClass]="{'firstColumn': title === 'referrals'}">
      <app-column-menu
        [columnName]="getColumnName()"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.userNameMenu"
        [icon]="'advertising'"
        [filterMenuOptions]="filterMenuOptions?.userNameMenu"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [tableTitle]="title"
        [menuName]="'userNameMenu'"
        [menuTitle]="'username'"
        [activeSortMethod]="activeSortMethod"
        [currency]="currency"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)"></app-column-menu>
    </div>
  </th>

  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('campaignMenu',true)"
    scope="col"
    class="option no-padding column campaign"
    [ngClass]="{'active': availableMenus.campaignMenu, 'wider-column' : title !== 'stats_daily' && title !== 'countries', 'active-sort': activeFilterMenus.campaignMenu}"
    *ngIf="title !== 'subid' && title !== 'ivr' && title !== 'PPI' && title !== 'referrals'">
    <div class="clickable" (click)="menuHandler('campaignMenu')">
      <span *ngIf="title !== 'stats_daily' && title !== 'countries'">
        <span *ngIf="title === 'ivr'; else fullCampaignNameAndID"> {{ 'view_translations.campaign_id' | translate }} </span>
        <ng-template #fullCampaignNameAndID> {{ 'view_translations.campaign' | translate }} ({{ 'view_translations.campaign_id' | translate }}) </ng-template>
      </span>
      <span *ngIf="title === 'stats_daily'">{{ 'view_translations.one_day' | translate | titlecase }}</span>
      <span *ngIf="title === 'countries'">{{ 'view_translations.country' | translate | titlecase }}</span>
      <div class="icons-container">
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter"
          *ngIf="activeSortMethod?.orderField === 'program_id' || activeSortMethod?.orderField === 'day' || activeSortMethod?.orderField === 'country' || activeSortMethod?.orderField === 'username'"></nb-icon>
      </div>
    </div>
    <div class="column-menu" [ngClass]="{'firstColumn': title === 'stats_daily' || title === 'countries' || title === 'ivr'}">
      <app-column-menu
        [columnName]="getColumnName()"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.campaignMenu"
        [icon]="'advertising'"
        [filterMenuOptions]="filterMenuOptions?.campaignMenu"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [tableTitle]="title"
        [menuName]="'campaignMenu'"
        [menuTitle]="title === 'stats_daily' ? 'one_day' : (title === 'referrals' ? 'username' : (title === 'countries' ? 'country' : 'campaign'))"
        [activeSortMethod]="activeSortMethod"
        [currency]="currency"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)"></app-column-menu>
    </div>
  </th>

  <!-- admin campaigns -->
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('adminCampaignMenu',true)"
    scope="col"
    class="option no-padding column campaign"
    [ngClass]="{'active': availableMenus.adminCampaignMenu, 'active-sort': activeFilterMenus.adminCampaignMenu}"
    *ngIf="title === 'incent_campaigns_stats' || title === 'smartlinks_stats'">
    <div class="clickable" (click)="menuHandler('adminCampaignMenu')">
      <span>
        {{ title === 'incent_campaigns_stats' ? ('view_translations.incent_campaign' | translate ) : ('view_translations.smartlink_campaign' | translate ) }} (
        ID )
      </span>
      <div class="icons-container">
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter"
          *ngIf="activeSortMethod?.orderField === 'admin_program_id'"></nb-icon>
      </div>
    </div>
    <div class="column-menu">
      <app-column-menu
        [columnName]="title === 'incent_campaigns_stats' ? 'incent_campaign' : 'smartlink_campaign'"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.adminCampaignMenu"
        [icon]="'advertising'"
        [filterMenuOptions]="filterMenuOptions?.adminCampaignMenu"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [tableTitle]="title"
        [menuName]="'adminCampaignMenu'"
        [menuTitle]="title === 'incent_campaigns_stats' ? 'incent_campaign' : 'smartlink_campaign'"
        [activeSortMethod]="activeSortMethod"
        [currency]="currency"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)"></app-column-menu>
    </div>
  </th>
  <!-- admin campaigns END -->

  <!-- configurations -->
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('configurationNameMenu',true)"
    scope="col"
    class="option no-padding lead column global-transition"
    [ngClass]="{'active': availableMenus.configurationNameMenu, 'active-sort': activeFilterMenus.configurationNameMenu }"
    *ngIf="checkIfColumnActive('configurationName', activeColumnsNames)">
    <div class="clickable" (click)="menuHandler('configurationNameMenu')">
      <span>{{ 'view_translations.ivr_name' | translate }} ({{ 'view_translations.config_id_statistics_table' | translate }})</span>
      <div class="icons-container">
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter"
          *ngIf="activeSortMethod?.orderField === 'config_id'"></nb-icon>
      </div>
    </div>
    <div class="column-menu" [ngClass]="{'firstColumn': firstColumn === 'configurationName'}">
      <app-column-menu
        columnName="configurationName"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.configurationNameMenu && title !== 'campaigns_details_stats'"
        [icon]="'lead'"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [menuName]="'configurationNameMenu'"
        [filterMenuOptions]="filterMenuOptions?.configurationNameMenu"
        [menuTitle]="'configuration_name'"
        [currency]="currency"
        [activeSortMethod]="activeSortMethod"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>
  <!-- configurations END -->
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('leadIDMenu',true)"
    scope="col"
    class="option no-padding lead column global-transition"
    [ngClass]="{'active': availableMenus.leadIDMenu, 'active-sort': activeFilterMenus.leadIDMenu }"
    *ngIf="checkIfColumnActive('leadID', activeColumnsNames)">
    <div class="clickable" (click)="menuHandler('leadIDMenu')">
      <span>{{ 'view_translations.' + 'lead_id' | translate }}</span>
      <div class="icons-container">
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter biger"
          *ngIf="activeSortMethod?.orderField === 'id'"></nb-icon>
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
      </div>
    </div>
    <div class="column-menu smaller">
      <app-column-menu
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.leadIDMenu"
        [icon]="''"
        columnName="leadID"
        [filterMenuOptions]="filterMenuOptions?.leadIDMenu || filterMenuOptions?.visitIDMenu"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [tableTitle]="title"
        [menuName]="'leadIDMenu'"
        [menuTitle]="'lead_id'"
        [activeSortMethod]="activeSortMethod"
        [currency]="currency"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>

  <th scope="col" class="option no-padding lead column global-transition noHover" *ngIf="checkIfColumnActive('orderId', activeColumnsNames)">
    <div class="clickable">
      <span>{{ 'view_translations.order_id' | translate }}</span>
    </div>
  </th>

  <th scope="col" class="option no-padding lead column global-transition noHover" *ngIf="checkIfColumnActive('additionalData', activeColumnsNames)">
    <div class="clickable">
      <span>{{ 'view_translations.additional_data' | translate }}</span>
    </div>
  </th>

  <th scope="col" class="option no-padding lead column global-transition noHover" *ngIf="checkIfColumnActive('cartValue', activeColumnsNames)">
    <div class="clickable">
      <span>{{ 'view_translations.cart_value' | translate }}</span>
    </div>
  </th>

  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('visitIDMenu',true)"
    scope="col"
    class="option no-padding lead column global-transition"
    [ngClass]="{'active': availableMenus.visitIDMenu, 'active-sort': activeFilterMenus.visitIDMenu}"
    *ngIf="checkIfColumnActive('visitID', activeColumnsNames)">
    <div class="clickable" (click)="menuHandler('visitIDMenu')">
      <span>{{ 'view_translations.' + 'visit_id' | translate }}</span>
      <div class="icons-container">
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter biger"
          *ngIf="activeSortMethod?.orderField === 'id'"></nb-icon>
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
      </div>
    </div>
    <div class="column-menu smaller">
      <app-column-menu
        [appliedFiltersBar]="appliedFiltersBar"
        columnName="visitID"
        *ngIf="availableMenus.visitIDMenu"
        [icon]="''"
        [filterMenuOptions]="filterMenuOptions?.leadIDMenu || filterMenuOptions?.visitIDMenu"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [tableTitle]="title"
        [menuName]="'visitIDMenu'"
        [menuTitle]="'lead_id'"
        [activeSortMethod]="activeSortMethod"
        [currency]="currency"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('statusMenu',true)"
    scope="col"
    class="option no-padding lead column global-transition"
    [ngClass]="{'active': availableMenus.statusMenu, 'active-sort': activeFilterMenus.statusMenu}"
    *ngIf="checkIfColumnActive('status', activeColumnsNames)">
    <div class="clickable" (click)="menuHandler('statusMenu')">
      <span>{{ 'view_translations.status' | translate }}</span>
      <div class="icons-container">
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter biger"
          *ngIf="activeSortMethod?.orderField === 'status'"></nb-icon>
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
      </div>
    </div>
    <div class="column-menu smaller" [ngClass]="{'firstColumn': firstColumn === 'status'}">
      <app-column-menu
        columnName="status"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.statusMenu"
        [icon]="''"
        [filterMenuOptions]="filterMenuOptions?.statusMenu"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [tableTitle]="title"
        [menuName]="'statusMenu'"
        [menuTitle]="'status'"
        [activeSortMethod]="activeSortMethod"
        [currency]="currency"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('leadsMenu',true)"
    scope="col"
    class="option special no-padding lead column global-transition"
    [ngClass]="{'active': availableMenus.leadsMenu, 'active-sort': activeFilterMenus.leadsMenu}"
    *ngIf="checkIfColumnActive('leads', activeColumnsNames)">
    <div class="clickable" (click)="menuHandler('leadsMenu')">
      <span>{{ 'view_translations.leads' | translate }}</span>
      <div class="icons-container">
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter biger"
          *ngIf="activeSortMethod?.orderField === 'leads' || activeSortMethod?.orderField === 'number_of_leads'"></nb-icon>
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
      </div>
    </div>
    <div class="column-menu" [ngClass]="{'firstColumn': firstColumn === 'leads'}">
      <app-column-menu
        columnName="leads"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.leadsMenu"
        [icon]="'lead'"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [filterMenuOptions]="filterMenuOptions?.leadsMenu"
        [menuName]="'leadsMenu'"
        [menuTitle]="'leads'"
        [activeSortMethod]="activeSortMethod"
        [currency]="currency"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('earnsMenu',true)"
    scope="col"
    class="option special no-padding earnings column global-transition"
    [ngClass]="{'active': availableMenus.earnsMenu, 'active-sort': activeFilterMenus.earnsMenu}"
    *ngIf="checkIfColumnActive('earnings', activeColumnsNames)">
    <div class="clickable" (click)="menuHandler('earnsMenu')">
      <span>{{ 'view_translations.earns' | translate }}</span>
      <div class="icons-container">
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter"
          *ngIf="activeSortMethod?.orderField === 'earnings'"></nb-icon>
      </div>
    </div>
    <div class="column-menu" [ngClass]="{'firstColumn': firstColumn === 'earnings'}">
      <app-column-menu
        columnName="earnings"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.earnsMenu"
        [icon]="'money-bag-alt'"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [filterMenuOptions]="filterMenuOptions?.earnsMenu"
        [menuName]="'earnsMenu'"
        [menuTitle]="'earns'"
        [currency]="currency"
        [activeSortMethod]="activeSortMethod"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)"></app-column-menu>
    </div>
  </th>

  <div
    class="option no-padding lead column global-transition"
    [ngClass]="{'active': availableMenus.modelMenu}"
    *ngIf="checkIfColumnActive('model', activeColumnsNames)">
    <div class="clickable" (click)="menuHandler('modelMenu')">
      <span>{{ 'view_translations.table_model' | translate }}</span>
      <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
      <nb-icon
        icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
        pack="icomoon"
        class="icon-filter"
        *ngIf="activeSortMethod?.orderField === 'table_model'"></nb-icon>
    </div>
    <div class="column-menu smaller" [ngClass]="{'firstColumn': firstColumn === 'model'}">
      <app-column-menu
        columnName="model"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.modelMenu"
        [icon]="''"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [tableTitle]="title"
        [menuName]="'modelMenu'"
        [menuTitle]="'table_model'"
        [currency]="currency"
        (closeMenu)="menuHandler($event, true)">
      </app-column-menu>
    </div>
  </div>
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('visitsMenu',true)"
    scope="col"
    class="option special no-padding column lead global-transition"
    [ngClass]="{'active': availableMenus.visitsMenu, 'active-sort': activeFilterMenus.visitsMenu}"
    *ngIf="checkIfColumnActive('uniqueVisits', activeColumnsNames)">
    <div class="clickable" (click)="menuHandler('visitsMenu')">
      <span>{{ 'view_translations.visits' | translate }}</span>
      <div class="icons-container">
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter"
          *ngIf="activeSortMethod?.orderField === 'visits'"></nb-icon>
      </div>
    </div>
    <div class="column-menu" [ngClass]="{'firstColumn': firstColumn === 'uniqueVisits'}">
      <app-column-menu
        columnName="uniqueVisits"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.visitsMenu"
        [icon]="'users-alt'"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [filterMenuOptions]="filterMenuOptions?.visitsMenu"
        [menuName]="'visitsMenu'"
        [menuTitle]="'visits'"
        [activeSortMethod]="activeSortMethod"
        [currency]="currency"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('conversionMenu',true)"
    scope="col"
    class="option column no-padding lead global-transition"
    [ngClass]="{'active': availableMenus.conversionMenu, 'active-sort': activeFilterMenus.conversionMenu}"
    *ngIf="checkIfColumnActive('conversion', activeColumnsNames)">
    <div class="clickable" (click)="menuHandler('conversionMenu')">
      <span>{{ 'view_translations.conversion' | translate | titlecase }}</span>
      <div class="icons-container">
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter"
          *ngIf="activeSortMethod?.orderField === 'conversion'"></nb-icon>
      </div>
    </div>
    <div class="column-menu" [ngClass]="{'firstColumn': firstColumn === 'conversion'}">
      <app-column-menu
        columnName="conversion"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.conversionMenu"
        [icon]="'conversion'"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [filterMenuOptions]="filterMenuOptions?.conversionMenu"
        [menuName]="'conversionMenu'"
        [menuTitle]="'conversion'"
        [currency]="currency"
        [activeSortMethod]="activeSortMethod"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('acceptanceMenu',true)"
    scope="col"
    class="option special acceptance no-padding lead column global-transition"
    [ngClass]="{'active': availableMenus.acceptanceMenu, 'active-sort': activeFilterMenus.acceptanceMenu}"
    *ngIf="checkIfColumnActive('acceptance', activeColumnsNames)">
    <div class="clickable" (click)="menuHandler('acceptanceMenu')">
      <span>{{ 'view_translations.acceptance_factor' | translate }}</span>
      <div class="icons-container">
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter"
          *ngIf="activeSortMethod?.orderField === 'acceptance'"></nb-icon>
      </div>
    </div>
    <div class="column-menu" [ngClass]="{'firstColumn': firstColumn === 'acceptance'}">
      <app-column-menu
        columnName="acceptance"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.acceptanceMenu"
        [icon]="'like'"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [filterMenuOptions]="filterMenuOptions?.acceptanceMenu"
        [menuName]="'acceptanceMenu'"
        [menuTitle]="'acceptance_factor'"
        [currency]="currency"
        [activeSortMethod]="activeSortMethod"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('epcMenu',true)"
    scope="col"
    class="option no-padding lead column global-transition"
    [ngClass]="{'active': availableMenus.epcMenu, 'active-sort': activeFilterMenus.epcMenu}"
    *ngIf="checkIfColumnActive('epc', activeColumnsNames)">
    <div class="clickable" (click)="menuHandler('epcMenu')">
      <span>{{ 'view_translations.epc' | translate }}</span>
      <div class="icons-container">
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter"
          *ngIf="activeSortMethod?.orderField === 'epc'"></nb-icon>
      </div>
    </div>
    <div class="column-menu" [ngClass]="{'firstColumn': firstColumn === 'epc'}">
      <app-column-menu
        columnName="epc"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.epcMenu"
        [icon]="'epc'"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [filterMenuOptions]="filterMenuOptions?.epcMenu"
        [menuName]="'epcMenu'"
        [menuTitle]="'epc'"
        [currency]="currency"
        [activeSortMethod]="activeSortMethod"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('rateMenu',true)"
    scope="col"
    class="option no-padding lead column global-transition"
    [ngClass]="{'active': availableMenus.rateMenu, 'active-sort': activeFilterMenus.rateMenu}"
    *ngIf="checkIfColumnActive('rate', activeColumnsNames)">
    <div class="clickable" (click)="menuHandler('rateMenu')">
      <span>{{ 'view_translations.just_payout' | translate }}</span>
      <!--      <span>{{ 'view_translations.rate' | translate }}</span>-->
      <div class="icons-container">
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter"
          *ngIf="activeSortMethod?.orderField === 'rate' || activeSortMethod?.orderField === 'amount'"></nb-icon>
      </div>
    </div>
    <div class="column-menu" [ngClass]="{'firstColumn': firstColumn === 'rate'}">
      <app-column-menu
        columnName="rate"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.rateMenu"
        [icon]="'epc'"
        [filterMenuOptions]="filterMenuOptions?.rateMenu"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [menuName]="'rateMenu'"
        [menuTitle]="'rate'"
        [activeSortMethod]="activeSortMethod"
        [currency]="currency"
        [activeSortMethod]="activeSortMethod"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('countriesMenu',true)"
    scope="col"
    class="option no-padding lead column global-transition"
    [ngClass]="{'active': availableMenus.countriesMenu, 'active-sort': activeFilterMenus.countriesMenu}"
    *ngIf="checkIfColumnActive('countries', activeColumnsNames)">
    <div class="clickable" (click)="menuHandler('countriesMenu')">
      <span>{{ 'view_translations.countries' | translate }}</span>
      <div class="icons-container">
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter"
          *ngIf="activeSortMethod?.orderField === 'countries'"></nb-icon>
      </div>
    </div>
    <div class="column-menu" [ngClass]="{'firstColumn': firstColumn === 'countries'}">
      <app-column-menu
        columnName="countries"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.countriesMenu"
        [icon]="''"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [filterMenuOptions]="filterMenuOptions?.countriesMenu"
        [menuName]="'countriesMenu'"
        [menuTitle]="'countries'"
        [currency]="currency"
        [activeSortMethod]="activeSortMethod"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('refferingMenu',true)"
    scope="col"
    class="option no-padding lead column global-transition"
    [ngClass]="{'active': availableMenus.refferingMenu}"
    *ngIf="checkIfColumnActive('refferingAddress', activeColumnsNames)">
    <div class="clickable" (click)="menuHandler('refferingMenu')">
      <span>{{ 'view_translations.referring_address' | translate }}</span>
      <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
    </div>
    <div class="column-menu" [ngClass]="{'firstColumn': firstColumn === 'refferingAddress'}">
      <app-column-menu
        columnName="refferingAddress"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.refferingMenu"
        [icon]="''"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [tableTitle]="title"
        [filterMenuOptions]="filterMenuOptions?.refferingMenu"
        [menuName]="'refferingMenu'"
        [menuTitle]="'referring_address'"
        [currency]="currency"
        [activeSortMethod]="activeSortMethod"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('mlSubMenu',true)"
    scope="col"
    class="option no-padding lead column global-transition"
    [ngClass]="{'active': availableMenus.mlSubMenu, 'noHover': !filterMenuOptions?.mlSubMenu}"
    *ngIf="checkIfColumnActive('mlSub', activeColumnsNames)">
    <div *ngIf="filterMenuOptions?.mlSubMenu; else noFiltersMenu" (click)="menuHandler('mlSubMenu')" class="clickable">
      <span>Ml_sub</span>
      <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
    </div>
    <ng-template #noFiltersMenu>
      <div class="clickable">
        <span>Ml_sub</span>
      </div>
    </ng-template>
    <div class="column-menu smaller" [ngClass]="{'firstColumn': firstColumn === 'mlSub'}">
      <app-column-menu
        columnName="mlSub"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.mlSubMenu"
        [icon]="''"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [tableTitle]="title"
        [filterMenuOptions]="filterMenuOptions?.mlSubMenu"
        [menuName]="'mlSubMenu'"
        [menuTitle]="'ml_sub'"
        [activeSortMethod]="activeSortMethod"
        [currency]="currency"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>

  <th scope="col" class="option no-padding lead column global-transition noHover" *ngIf="checkIfColumnActive('transactionId', activeColumnsNames)">
    <div class="clickable">
      <span>{{ 'view_translations.transaction_id' | translate }}</span>
    </div>
  </th>
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('createdAtMenu',true)"
    scope="col"
    class="option no-padding lead column global-transition"
    [ngClass]="{'active': availableMenus.createdAtMenu, 'active-sort': activeFilterMenus.createdAtMenu, 'noHover': !filterMenuOptions?.createdAtMenu}"
    *ngIf="checkIfColumnActive('created', activeColumnsNames)">
    <div class="clickable" (click)="filterMenuOptions?.createdAtMenu ? menuHandler('createdAtMenu') : undefined">
      <span>{{ 'view_translations.created_at' | translate }}</span>
      <div *ngIf="filterMenuOptions?.createdAtMenu" class="icons-container">
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter"
          *ngIf="activeSortMethod?.orderField === 'date_created'"></nb-icon>
      </div>
    </div>
    <div class="column-menu">
      <app-column-menu
        columnName="created"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.createdAtMenu"
        [icon]="''"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [filterMenuOptions]="filterMenuOptions?.createdAtMenu"
        [menuName]="'createdAtMenu'"
        [menuTitle]="'created_at'"
        [currency]="currency"
        [activeSortMethod]="activeSortMethod"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>
  <th scope="col" class="option no-padding lead column global-transition noHover" *ngIf="checkIfColumnActive('updated', activeColumnsNames)">
    <div class="clickable">
      <span>{{ 'view_translations.updated_at' | translate }}</span>
    </div>
  </th>
  <th scope="col" class="option no-padding lead column global-transition noHover" *ngIf="checkIfColumnActive('browser', activeColumnsNames)">
    <div class="clickable">
      <span>{{ 'view_translations.browser' | translate }}</span>
    </div>
  </th>
  <th scope="col" class="option no-padding lead column global-transition noHover" *ngIf="checkIfColumnActive('browserVersion', activeColumnsNames)">
    <div class="clickable">
      <span>{{ 'view_translations.browser_version' | translate }}</span>
    </div>
  </th>
  <th scope="col" class="option no-padding lead column global-transition noHover" *ngIf="checkIfColumnActive('operatingSystem', activeColumnsNames)">
    <div class="clickable">
      <span>{{ 'view_translations.operating_system' | translate }}</span>
    </div>
  </th>
  <th scope="col" class="option no-padding lead column global-transition noHover" *ngIf="checkIfColumnActive('operatingSystemVersion', activeColumnsNames)">
    <div class="clickable">
      <span>{{ 'view_translations.operating_system_version' | translate }}</span>
    </div>
  </th>
  <th scope="col" class="option no-padding lead column global-transition noHover" *ngIf="checkIfColumnActive('device', activeColumnsNames)">
    <div class="clickable">
      <span>{{ 'view_translations.device' | translate }}</span>
    </div>
  </th>
  <th scope="col" class="option no-padding lead column global-transition noHover" *ngIf="checkIfColumnActive('sources', activeColumnsNames)">
    <div class="clickable">
      <span>{{ 'view_translations.traffic_sources' | translate }}</span>
    </div>
  </th>
  <th scope="col" class="option no-padding lead column global-transition noHover" *ngIf="checkIfColumnActive('categories', activeColumnsNames)">
    <div class="clickable">
      <span>{{ 'view_translations.categories' | translate }}</span>
    </div>
  </th>
  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('salesMenu',true)"
    scope="col"
    class="option no-padding lead column global-transition"
    [ngClass]="{'active': availableMenus.salesMenu}"
    *ngIf="false">
    <div class="clickable" (click)="menuHandler('salesMenu')">
      <span>{{ 'view_translations.sales_value' | translate }}</span>
      <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
      <nb-icon
        icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
        pack="icomoon"
        class="icon-filter"
        *ngIf="activeSortMethod?.orderField === 'amount'"></nb-icon>
    </div>
    <div class="column-menu" [ngClass]="{'firstColumn': false}">
      <app-column-menu
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.salesMenu"
        [icon]="'users-alt'"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [menuName]="'salesMenu'"
        [menuTitle]="'sales_value'"
        [activeSortMethod]="activeSortMethod"
        [currency]="currency"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)">
      </app-column-menu>
    </div>
  </th>
  <th scope="col" class="option no-padding lead column global-transition noHover" *ngIf="checkIfColumnActive('safePage', activeColumnsNames)">
    <div class="clickable">
      <span>{{ 'view_translations.safe_page' | translate }}</span>
    </div>
  </th>
  <th scope="col" class="option no-padding lead column global-transition noHover" *ngIf="checkIfColumnActive('placeOfPromotion', activeColumnsNames)">
    <div class="clickable">
      <span>{{ 'view_translations.place_of_promotion' | translate }}</span>
    </div>
  </th>

  <th
    appClickOutsideComponent
    (clickOutside)="menuHandler('registrationAtMenu',true)"
    scope="col"
    class="option no-padding column campaign"
    [ngClass]="{'active': availableMenus.registrationAtMenu, 'wider-column' : true, 'active-sort': activeFilterMenus.registrationAtMenu}"
    *ngIf="title === 'referrals'">
    <div class="clickable" (click)="menuHandler('registrationAtMenu')">
      <span>{{ 'view_translations.registration_date' | translate }}</span>
      <div class="icons-container">
        <nb-icon icon="chevron-down" pack="icomoon" class="icon"></nb-icon>
        <nb-icon
          icon="{{activeSortMethod?.orderType === 'desc' ? 'sort' : 'sort-alt'}}"
          pack="icomoon"
          class="icon-filter"
          *ngIf="activeSortMethod?.orderField === 'registration_date'"></nb-icon>
      </div>
    </div>
    <div class="column-menu" [ngClass]="{'firstColumn': false}">
      <app-column-menu
        [columnName]="getColumnName()"
        [appliedFiltersBar]="appliedFiltersBar"
        *ngIf="availableMenus.registrationAtMenu"
        [icon]="'advertising'"
        [filterMenuOptions]="filterMenuOptions?.registrationAtMenu"
        [isDetailsTableLayout]="isDetailsTableLayout"
        [tableTitle]="title"
        [menuName]="'registrationAtMenu'"
        [menuTitle]="'registration_date'"
        [activeSortMethod]="activeSortMethod"
        [currency]="currency"
        (closeMenu)="menuHandler($event, true)"
        (getOpenedColumnMenuHeight)="saveOpenedColumnMenuHeight($event)"></app-column-menu>
    </div>
  </th>
</ng-container>
